import { initSearchInput } from "@opportunus-lib-js/store/store-search-input";
import { initTabs } from "./tabs";

initSearchInput();
initTabs();
